"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkIsGoogleCrawler = void 0;
var googleBotUserAgents = [
    'Googlebot',
    'Google-InspectionTool',
    'AdsBot-Google',
    'AdsBot-Google-Mobile',
    'AdsBot-Google-Mobile-Apps',
    'Mediapartners-Google',
    'Googlebot-Image',
    'Googlebot-Video',
    'Googlebot-News',
    'APIs-Google',
];
exports.checkIsGoogleCrawler = (function () {
    var patterns = new RegExp(googleBotUserAgents.slice().join('|'), 'i');
    return function (ua) {
        return patterns.test(ua);
    };
})();
